import { TranslationScopes } from "@finbackoffice/enums";
import { DropdownOption } from "@finbackoffice/site-core";
import classNames from "classnames";
import { JSX, FC } from "react";
import FadeInAnimation from "../fade-in/FadeInAnimation";
import { Svg } from "../svg/Svg";
import Translate from "../translate/Translate";
import styles from "./custom-select.module.sass";

type IProps = {
    data: DropdownOption[];
    selected: string | string[];
    onClickHandler: (value: string) => void;
    onCheckboxlClick: (value: string) => void;
    multiple: boolean;
    renderItem: ((item: DropdownOption) => JSX.Element) | undefined;
};

const List: FC<IProps> = ({
    data,
    selected,
    onClickHandler,
    onCheckboxlClick,
    multiple,
    renderItem,
}) => (
    <FadeInAnimation>
        <ul>
            {data.map((item) => (
                <li
                    key={item.value}
                    value={item.value}
                    className={classNames(
                        (multiple
                            ? selected.indexOf(item.value) !== -1
                            : selected === item.value) && "selected",
                    )}
                    onClick={() => onClickHandler(item.value)}
                    role="presentation">
                    {multiple && item.value && (
                        <label
                            htmlFor={`checkbox_${item.value}`}
                            className={classNames(
                                "ui-checkbox",
                                styles.checkbox,
                                selected.indexOf(item.value) !== -1 && "checked",
                            )}>
                            <input type="checkbox" id={`checkbox_${item.value}`} />
                            <i
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    onCheckboxlClick(item.value);
                                }}
                            />
                        </label>
                    )}
                    {item.iconClass && <i className={item.iconClass} />}
                    {item.svgSrc && <Svg src={item.svgSrc} className="svg-icon" />}
                    {renderItem ? (
                        renderItem(item)
                    ) : (
                        <Translate
                            tid={typeof item.label === "string" ? item.label : item.label.tid}
                            namespace={
                                typeof item.label !== "string"
                                    ? item.label.namespace
                                    : TranslationScopes.Common
                            }
                        />
                    )}
                </li>
            ))}
        </ul>
    </FadeInAnimation>
);

export default List;
